export function getOrderStatusDescription(value: number) {
  switch (value) {
    case 0:
      return `AGUARDANDO RETIRADA`
    case 1:
      return ``
    case 2:
      return ``
    case 3:
      return ``
    case 4:
      return `EXPIRADA`
    case 5:
      return `RETIRADA`
    case 6:
      return ``
    case 7:
      return `AGUARDANDO FECHAMENTO DA PORTA`
    case 8:
      return `PENDENTE`
    case 9:
      return `CANCELADA`
    case 10:
      return `AGUARDANDO RETIRADA`
    case 12: // transação excluída
      return `CANCELADA`
    case 13:
      return `COLETADA`
    default:
      return ``
  }
}

export function getAddreessesStatusDescription(value: number) {
  switch (value) {
    case 0:
      return `ATIVO`
    case 1:
      return `INATIVO`
    case 2:
      return `EXCLUIDO`
    default:
      return ``
  }
}

export function getLevelUser(value: number) {
  switch (value) {
    case 0:
      return `DESTINATÁRIO`
    case 1:
      return `ADMINISTRADOR`
    default:
      return ``
  }
}

export function getStatusBox(value: number) {
  switch (value) {
    case 0:
      return 'NÃO REGISTRADO'
    case 1:
      return 'DISPONÍVEL'
    case 2:
      return 'AGUARDANDO RETIRADA'
    case 3:
      return 'RETIRADA EM ANDAMENTO'
    case 4:
      return 'RETIRADA FINALIZADA'
    case 5:
      return 'RETIRADA EXPIRADA'
    case 6:
      return 'FALHA NA ABERTURA'
    case 7:
      return 'INATIVO'
    case 8:
      return 'VIOLADO'
    default:
      return ''
  }
}

export function getStatusMCM(value: number) {
  switch (value) {
    case 0:
      return 'ATIVO'
    case 1:
      return 'INATIVO'
    case 2:
      return 'EXCLUÍDO'
    default:
      return ''
  }
}
